import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { useAuth } from '../contexts/AuthContext';
import { getToken, hasPendingExchangeTicket } from '../utils/auth';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user: userContextUser, loading: userContextLoading } = useContext(UserContext);
  const { user: authUser, loading: authLoading } = useAuth();
  
  const token = getToken();
  const hasTicket = hasPendingExchangeTicket();
  const isAuthenticated = !!token || !!authUser;
  const loading = userContextLoading || authLoading || hasTicket;
  
  // Show loading when checking authentication
  if (loading) {
    return (
      <div 
        className="flex justify-center items-center h-screen"
        style={{ background: 'linear-gradient(to bottom, #0c0d1f, #1b1324)' }}
      >
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-400"></div>
      </div>
    );
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Render the protected component
  return <>{children}</>;
};

export default PrivateRoute; 